export const LINKEDIN_URL_PATTERN_REG_EXP =
  /^(ftp|http|https):\/\/?((www|\w\w)\.)?linkedin.com(\w+:{0,1}\w*@)?(\S+)(:([0-9])+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
export const LINKEDIN_URL_OR_CV_VALIDATION_MESSAGE =
  "Please submit either your LinkedIn profile URL OR Upload CV for review.";
